import { writable } from 'svelte/store';
// eslint-disable-next-line no-undef
const configFromRollup = __appConfig;
const baseConfig = {
    baseUrl: 'http://localhost:5000',
    apiUrl: 'http://localhost:3030',
    redirectUrl: 'http://localhost:3030/oauth/twitch',
};
Object.keys(configFromRollup).forEach((key) => {
    if (configFromRollup[key]) {
        baseConfig[key] = configFromRollup[key];
    }
});
export const applicationConfigStore = writable(baseConfig);
